module.exports = __webpack_public_path__ + "media/en_au_s1_Daisy.06a7f8d9.oga";